// Service data with routes for detail pages
export const services = [
  {
    id: "unified-communications",
    slug: "unified-communications",
    name: "Unified Communications & Collaborations",
    shortDescription: "Enhance teamwork, customer engagement, and productivity with integrated communication solutions.",
    valueStatement: "Connect your teams and customers seamlessly with enterprise-grade communication solutions that drive collaboration and productivity.",
    icon: "Phone",
    color: "primary",
    route: "/services/unified-communications",
    image: "/img/header/unified.png",
    benefits: [
      "Improved collaboration with beneficiaries/partners",
      "Enhanced customer experience",
      "Reduced communication costs",
      "Increased mobility and flexibility"
    ],
    offerings: [
      "VOIP and telephony services tailored to your business needs.",
      "Call Center & Contact Center Solutions",
      "Audio and Video conferencing systems",
      "Collaboration Tools"
    ],
    useCases: [
      "Enterprise call centers requiring high availability and scalability",
      "Multi-branch organizations needing unified communication across locations",
      "Remote and hybrid teams requiring seamless collaboration tools",
      "Healthcare facilities needing reliable patient communication systems",
      "Educational institutions implementing distance learning platforms",
      "Government agencies modernizing citizen engagement channels"
    ],
    supportedTech: [
      { name: "Mitel", logo: "https://www.mitel.com/-/media/images/logos/mitel-logo-2020.png" },
      { name: "Grandstream", logo: "https://www.grandstream.com/hubfs/grandstream-logo.svg" },
      { name: "Yeastar", logo: null }
    ]
  },
  {
    id: "networks",
    slug: "networks",
    name: "Networks",
    shortDescription: "Design, implement, and manage robust, secure, and scalable network infrastructure solutions.",
    valueStatement: "Build the backbone of your digital operations with enterprise networks designed for performance, security, and growth.",
    icon: "Network",
    color: "accent",
    route: "/services/networks",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&auto=format&fit=crop&q=80",
    benefits: [
      "Reliable and secure network connectivity",
      "Improved network performance and uptime",
      "Enhanced scalability and flexibility",
      "Simplified network management"
    ],
    offerings: [
      "Network Audits",
      "Network Security including Firewall Configuration",
      "Network Design and Architecture",
      "Network Monitoring and Optimization",
      "Wireless Networking (WLAN)",
      "Network Virtualization",
      "LAN | WAN Implementation and Management",
      "Software-Defined Wide Area Network (SD-WAN) Solutions"
    ],
    useCases: [
      "Corporate headquarters requiring high-speed, secure campus networks",
      "Retail chains needing reliable connectivity across multiple stores",
      "Hotels and hospitality venues implementing guest WiFi solutions",
      "Manufacturing facilities deploying industrial IoT networks",
      "Financial institutions requiring low-latency trading networks",
      "Schools and universities building campus-wide wireless infrastructure"
    ],
    supportedTech: [
      { name: "Ubiquiti", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Ubiquiti_Logo.svg/512px-Ubiquiti_Logo.svg.png" },
      { name: "Ruijie", logo: "https://www.ruijienetworks.com/static/img/logo.png" },
      { name: "Teltonika", logo: "https://teltonika-networks.com/cdn/extras/13629/teltonika-networks-logo-white-1-.png" }
    ]
  },
  {
    id: "technology-infrastructure",
    slug: "technology-infrastructure",
    name: "Technology Infrastructure",
    shortDescription: "Build the physical foundation that supports your entire IT environment with enterprise-grade solutions.",
    valueStatement: "Establish a solid technological foundation with scalable infrastructure solutions that support your business today and tomorrow.",
    icon: "Server",
    color: "primary",
    route: "/services/technology-infrastructure",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&auto=format&fit=crop&q=80",
    benefits: [
      "Reduced Downtime",
      "Scalability",
      "Flexibility",
      "Cost Savings",
      "Improved ROI",
      "Business Agility",
      "Loyalty"
    ],
    offerings: [
      "Hardware (servers, storage, data centers)",
      "CCTV and Access Control",
      "Software (operating systems, applications)",
      "Power and cooling systems",
      "IT service management (ITSM) tools",
      "Cloud infrastructure",
      "Data center infrastructure (cabling, racks, etc.)"
    ],
    useCases: [
      "Enterprises building or upgrading data center facilities",
      "Organizations implementing physical security and surveillance systems",
      "Businesses migrating to hybrid cloud infrastructure",
      "Facilities requiring UPS and power management solutions",
      "Companies needing structured cabling for new office builds",
      "Institutions deploying server virtualization environments"
    ],
    supportedTech: [
      { name: "HPE", logo: "https://upload.wikimedia.org/wikipedia/commons/4/46/Hewlett_Packard_Enterprise_logo.svg" },
      { name: "Giganet", logo: null },
      { name: "Siemon", logo: "https://www.siemon.com/App_Themes/Siemon/Images/siemon-logo.svg" },
      { name: "APC", logo: null },
      { name: "Hikvision", logo: "https://www.hikvision.com/content/dam/hikvision/en/marketing/image/logo/logo.png" }
    ]
  },
  {
    id: "cyber-security",
    slug: "cyber-security",
    name: "Cyber Security",
    shortDescription: "Protect your organization with comprehensive security solutions in today's threat landscape.",
    valueStatement: "Safeguard your digital assets with proactive security measures that detect, prevent, and respond to evolving cyber threats.",
    icon: "Shield",
    color: "accent",
    route: "/services/cyber-security",
    image: "/img/header/cyber.png",
    benefits: [
      "Enhanced security posture",
      "Reduced risk of data breaches",
      "Improved compliance",
      "Proactive threat detection and response"
    ],
    offerings: [
      "Risk assessment and vulnerability management",
      "Firewall sourcing, configuration and management",
      "Intrusion detection and prevention systems (IDPS)",
      "Endpoint Security",
      "Data Encryption and Backup",
      "Penetration testing and Incident Reponses",
      "Security information and Event management (SIEM)",
      "Managed Detection and Response"
    ],
    addons: [
      {
        name: "Data Backup & Replication",
        offerings: [
          "Backup strategy and policy design",
          "Backup implementation (on-prem, cloud, hybrid)",
          "Backup monitoring and recovery testing",
          "Disaster recovery planning (RPO/RTO alignment)",
          "Replication for business continuity"
        ],
        note: "We support solutions such as Veeam for enterprise-grade backup and replication."
      }
    ],
    useCases: [
      "Financial institutions requiring PCI-DSS compliance",
      "Healthcare organizations protecting patient data (HIPAA)",
      "Government agencies implementing zero-trust architectures",
      "E-commerce platforms securing customer transactions",
      "Enterprises deploying endpoint protection across distributed workforces",
      "Organizations recovering from or preventing ransomware attacks"
    ],
    supportedTech: [
      { name: "Sophos", logo: "https://www.sophos.com/sites/default/files/2022-02/sophos-logo-white-rgb.png" },
      { name: "Check Point", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Check_Point_logo_2022.svg/512px-Check_Point_logo_2022.svg.png" },
      { name: "Barracuda", logo: "https://www.barracuda.com/assets/img/logo/barracuda_logo_core_blue.svg" },
      { name: "Microsoft", logo: "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg" },
      { name: "Veeam", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Veeam_logo.svg/512px-Veeam_logo.svg.png" }
    ]
  },
  {
    id: "av-automation-control",
    slug: "av-automation-control",
    name: "Audio-Visual, Automation and Control",
    shortDescription: "Transform spaces with integrated AV solutions that enhance productivity, safety, and customer experience.",
    valueStatement: "Create immersive, intelligent environments with AV and automation solutions that enhance experiences and streamline operations.",
    icon: "Monitor",
    color: "primary",
    route: "/services/av-automation-control",
    image: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=800&auto=format&fit=crop&q=80",
    settings: [
      "Conference Rooms and Boardrooms",
      "Classrooms and Training Facilities",
      "Auditoriums and Theaters",
      "Retail and Hospitality Environments",
      "Healthcare and Medical Facilities",
      "Government and Military Institutions",
      "Home Automation and Smart Living",
      "Churches",
      "Warehouse and Factories"
    ],
    offerings: [
      "Audio-Visual System Design and Installation",
      "Home Theatre and Automation Systems",
      "Smart Boardroom and Conference Room Solutions",
      "Video Wall and Display Solutions",
      "Automation and Control Systems (Lighting, HVAC)",
      "Digital Signage and Display Solutions",
      "Acoustic Design and Optimization",
      "Networked Audio and Video Distribution"
    ],
    useCases: [
      "Corporate boardrooms requiring integrated presentation systems",
      "Educational institutions building smart classrooms",
      "Houses of worship implementing sound and projection systems",
      "Hotels and conference centers needing scalable event AV",
      "Residential projects requiring home automation solutions",
      "Retail environments deploying digital signage networks"
    ],
    supportedTech: [
      { name: "Supported AV Ecosystems", logo: null }
    ],
    supportedTechNote: "We work with a variety of professional AV equipment manufacturers to deliver tailored solutions."
  },
  {
    id: "consulting",
    slug: "consulting",
    name: "Consulting",
    shortDescription: "Expert guidance for technology strategy, implementation, and optimization to achieve business goals.",
    valueStatement: "Navigate your digital transformation journey with expert guidance that aligns technology investments with business outcomes.",
    icon: "Lightbulb",
    color: "accent",
    route: "/services/consulting",
    image: "/img/header/consult.png",
    benefits: [
      "Improved productivity and efficiency",
      "Enhanced customer experience",
      "Increased revenue and competitiveness",
      "Better decision-making and strategic planning",
      "Reduced costs and improved ROI",
      "Improved risk management and compliance",
      "Enhanced collaboration and communication",
      "Increased agility and adaptability",
      "Better alignment of ICT with business objectives",
      "Access to specialized expertise"
    ],
    offerings: [
      "Technology Roadmap Development",
      "Change Management and Adoption",
      "ICT Strategy and Planning",
      "Digital Transformation Consulting",
      "Project Management and Implementation",
      "Solution Architecture and Design",
      "Cybersecurity Consulting"
    ],
    useCases: [
      "Organizations undergoing digital transformation initiatives",
      "Enterprises developing multi-year technology roadmaps",
      "Companies seeking to optimize IT spending and ROI",
      "Businesses requiring change management for new system rollouts",
      "Startups building scalable technology foundations",
      "Government agencies modernizing legacy systems"
    ],
    supportedTech: [
      { name: "Microsoft", logo: "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg" },
      { name: "HPE", logo: "https://upload.wikimedia.org/wikipedia/commons/4/46/Hewlett_Packard_Enterprise_logo.svg" },
      { name: "Sophos", logo: "https://www.sophos.com/sites/default/files/2022-02/sophos-logo-white-rgb.png" },
      { name: "Veeam", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Veeam_logo.svg/512px-Veeam_logo.svg.png" }
    ],
    supportedTechNote: "We provide consulting across various technology stacks and platforms."
  },
  {
    id: "renewable-energy",
    slug: "renewable-energy",
    name: "Renewable Energy for Off-Grid ICT (Solar)",
    shortDescription: "Solar power solutions for critical ICT services in remote and off-grid locations.",
    valueStatement: "Power your technology infrastructure sustainably with solar solutions designed for reliability in any location.",
    icon: "Sun",
    color: "accent",
    isSpecial: false,
    route: "/services/renewable-energy",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&auto=format&fit=crop&q=80",
    // EXACT content - Do not modify
    description: "We design and deploy solar power solutions that keep critical ICT services running in remote and off-grid locations\u2014supporting computer labs, libraries, connectivity equipment, and essential services.",
    detailBlock: {
      heading: "Renewable Energy for Remote ICT",
      content: "Reliable power is the foundation of reliable connectivity. Voitech is exploring and supporting solar-powered ICT deployments for off-grid and underserved areas\u2014helping schools, health centers, and community facilities run computer labs, connectivity, and basic digital services sustainably."
    },
    useCases: [
      "Solar + battery power for computer labs & e-libraries",
      "Power for connectivity sites (routers, radios, switches)",
      "Backup power to reduce downtime and diesel dependence"
    ],
    timeline: [
      { step: "Discover", description: "Understanding your power needs and challenges" },
      { step: "Site Survey", description: "Assessing location and infrastructure requirements" },
      { step: "System Design", description: "Creating a tailored solar solution" },
      { step: "Deployment", description: "Professional installation and setup" },
      { step: "Monitoring", description: "Ongoing system performance tracking" }
    ],
    supportedTech: []
  },
  {
    id: "data-backup-replication",
    slug: "data-backup-replication",
    name: "Data Backup & Replication",
    shortDescription: "Protect your critical business data with comprehensive backup solutions and disaster recovery planning.",
    valueStatement: "Safeguard your organization's most valuable asset—your data—with enterprise-grade backup and replication solutions that ensure business continuity.",
    icon: "Database",
    color: "primary",
    route: "/services/data-backup-replication",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&auto=format&fit=crop&q=80",
    benefits: [
      "Minimize data loss with robust backup strategies",
      "Rapid recovery from ransomware and disasters",
      "Meet compliance and regulatory requirements",
      "Reduce downtime and business disruption",
      "Protect against hardware failures and human error"
    ],
    // EXACT offerings - Do not modify
    offerings: [
      "Backup strategy and policy design",
      "Backup implementation (on-prem, cloud, hybrid)",
      "Backup monitoring and recovery testing",
      "Disaster recovery planning (RPO/RTO alignment)",
      "Replication for business continuity"
    ],
    useCases: [
      "Protecting file servers and critical workloads from data loss",
      "Ensuring business continuity for core enterprise systems",
      "Ransomware recovery readiness and incident response preparation",
      "Branch office backups to centralized storage infrastructure",
      "Cloud and hybrid backup modernization initiatives",
      "Routine recovery drills and compliance readiness programs"
    ],
    supportedTech: [
      { name: "Veeam", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Veeam_logo.svg/512px-Veeam_logo.svg.png" },
      { name: "Microsoft", logo: "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg" },
      { name: "HPE", logo: "https://upload.wikimedia.org/wikipedia/commons/4/46/Hewlett_Packard_Enterprise_logo.svg" },
      { name: "APC", logo: null }
    ],
    supportedTechNote: "We support solutions such as Veeam for enterprise-grade backup and replication.",
    relatedServiceIds: ["cyber-security", "technology-infrastructure", "consulting"]
  }
];

// Standard delivery methodology for all services
export const deliveryMethodology = [
  {
    step: "Discover & Assess",
    description: "Understanding your requirements, challenges, and existing infrastructure through detailed consultation."
  },
  {
    step: "Design & Architecture",
    description: "Creating tailored solution blueprints that align with your business objectives and technical requirements."
  },
  {
    step: "Supply & Implementation",
    description: "Procuring quality equipment and executing professional deployment following industry best practices."
  },
  {
    step: "Testing & Commissioning",
    description: "Rigorous testing to ensure all systems perform optimally before handover."
  },
  {
    step: "Training & Handover",
    description: "Comprehensive user training and documentation for seamless transition to operations."
  },
  {
    step: "Support & Optimization",
    description: "Ongoing maintenance, monitoring, and continuous improvement to maximize value."
  }
];

// Helper to get related services
export const getRelatedServices = (currentId, count = 3) => {
  const currentService = services.find(s => s.id === currentId);
  
  // If the service has specific related service IDs, use those
  if (currentService?.relatedServiceIds) {
    return currentService.relatedServiceIds
      .map(id => services.find(s => s.id === id))
      .filter(Boolean)
      .slice(0, count);
  }
  
  // Otherwise, return other services excluding current
  return services
    .filter(s => s.id !== currentId)
    .slice(0, count);
};
